var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "shadow rounded-lg",
      class: { "bg-white": !_vm.muted, "bg-cool-gray-50": _vm.muted },
    },
    [
      _vm.heading
        ? _c(
            "div",
            {
              staticClass:
                "border-b border-gray-200 px-4 py-5 sm:px-6 flex items-center justify-between",
            },
            [
              _c("h4", {
                staticClass: "text-lg leading-6 text-gray-900",
                domProps: { innerHTML: _vm._s(_vm.heading) },
              }),
              _vm._v(" "),
              _vm._t("header", null, {
                toggleCollapsed: _vm.toggleCollapsed,
                isCollapsed: _vm.collapsed,
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "px-4 sm:px-6",
          class: {
            "py-5 sm:py-6": !_vm.collapsable || !_vm.collapsed,
            "h-0 py-0 overflow-hidden": _vm.collapsable && _vm.collapsed,
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c(
            "div",
            { staticClass: "bg-gray-50 px-4 py-4 sm:px-6 rounded-b-lg" },
            [_vm._t("footer")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }